export default __webpack_public_path__ + "91994e345c947169241ff83d2c2113c4.svg";